<template>
  <div class="versionLast">
    <div class="lastTitle">
       新版模板消息(通知)设置
    </div>
    <div class="versionContent">
       <div class="oneCard" :key="templateItemIndex" @mouseenter="currentCardItemIndex=templateItemIndex" v-for="(templateItem,templateItemIndex) in templateList">
         <div class="settingItem">
            <el-input v-model="templateItem.title"></el-input>
            <div class="itemRightWidth" @click="deleteTemplateItem(templateItem,templateItemIndex)"><i class="el-icon-delete"></i></div>
         </div>
         <div class="settingItem">
            <el-select v-model="templateItem.temTypeValue" @change="actionType" filterable placeholder="选择类型">
                <el-option
                    v-for="item in templateItem.typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <div class="itemRightWidth"></div>
         </div>
         <div class="settingItem">
             <el-input v-model="templateItem.firstTitle" placeholder='first'></el-input>
             <div class="itemRightWidth">
               <el-color-picker v-model="templateItem.firstColor"></el-color-picker>
             </div>
         </div>
         <div class="settingItem" :key="keyWordItemIndex" v-for="(keyWordItem,keyWordItemIndex) in templateItem.keyWords">
             <el-input placeholder="关键词名称" class="specialInput" v-model="keyWordItem.keyNameText"></el-input>
             <el-input placeholder="keyword" class="specialInput" v-model="keyWordItem.keyName"></el-input>
            <el-select v-model="keyWordItem.keyValue" filterable placeholder="请选择">
                <el-option
                    v-for="item in keyWordItem.keyValueOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    >
                </el-option>
            </el-select>
             <div class=" specialItemRightWidth itemDelete"><el-color-picker v-model="keyWordItem.colorValue"></el-color-picker><i class="el-icon-delete" @click="deleteKeyWordItem(templateItem.keyWords,keyWordItemIndex)"></i></div>
         </div>
         <div class="settingItem">
             <el-button type="primary" icon="el-icon-plus" @click="addKeyWord(templateItem)">添加</el-button>
         </div>
         <div class="settingItem">
             <el-input placeholder='remark' v-model="templateItem.remark"></el-input>
             <div class="itemRightWidth">
               <el-color-picker v-model="templateItem.remarkColor"></el-color-picker>
             </div>
         </div>
         <div class="settingItem">
             <div class="itemLeftWidth">模板ID</div>
             <el-input placeholder='输入模板ID' v-model="templateItem.templateId"></el-input>
         </div>
         <div class="settingItem">
            <div class="itemLeftWidth">状态</div>
            <el-switch
                v-model="templateItem.temStatus"
                active-color="#409EFF"
                inactive-color="#DCDFE6">
            </el-switch>
            <el-button type='primary' @click="saveCardInfo(templateItemIndex)" style="margin-left:auto">保存</el-button>
         </div>

       </div>
       <div class="addCardContainer">
        <div class="addCard" @click="addCard()">
          <i class="el-icon-plus"></i>
        </div>
       </div>
    </div>
  </div>
</template>

<script>
  import api from '@/config/api';

  export default {
  data(){
      return{
          currentCardItemIndex:-1,
          keyValueOptions:[],//用于联动的关键词可选值，五种动作类型联动的关键词共用此变量
          templateList:[
            {
              id:'',
              title:'',
              temTypeValue:'',
              typeOptions:[{label:'啊啊',value:'A01'},{label:'哈哈哈',value:'A02'}],
              firstTitle:'',
              firstColor:'',
              keyWords:[
                  {
                    keyNameText:'',
                    keyName:'',
                    keyValue:'',
                    keyValueOptions:[{label:'啊啊',value:'A01'},{label:'哈哈哈',value:'A02'}],
                    colorValue:''
                  }
              ],
              remark:'',
              remarkColor:'',
              templateId:'',
              temStatus:true
            }
          ]
      }
  },
  created(){
    const loading=this.$loading();
    let url=api.system.lastTemplateListGet;
    this.templateList=[];
    this.$axios.fetchPost(url).then((res)=>{
        console.log('模板拉取',res.data)
        loading.close();
        if(res.code===200){
          for(let i=0;i<res.data.length;i++){
            let fieldsJson=JSON.parse(res.data[i].fieldsJson);
            let objectAdapter={
                id:res.data[i].id,
                title:fieldsJson.title,
                temTypeValue:res.data[i].type,
                typeOptions:this.$utils.getCacheStatus('sysMerchantTemplatePush.type'),
                firstTitle:fieldsJson.first,
                remark:fieldsJson.remark,
                firstColor:fieldsJson.first_color,
                keyWords:this.fixedKeyWords(fieldsJson.keyword_list),
                remarkColor:fieldsJson.remark_color,
                templateId:res.data[i].modelId,
                temStatus:res.data[i].open
            }
            this.templateList.push(objectAdapter);

            //根据type加载不同的keyValueOptions
            this.currentCardItemIndex=i;
            this.actionType(res.data[i].type,'initKeyValueOptions')
          }
        }
    })
  },
  methods:{
      saveCardInfo(templateItemIndex){
        let cardInfo=this.templateList[templateItemIndex];
        let url=api.system.lastTemplateListPush;
        let data={
            id:cardInfo.id,
            fieldsJson:{
                title:cardInfo.title,
                first:cardInfo.firstTitle,
                remark:cardInfo.remark,
                keyword_list:fixedKeywordList(cardInfo.keyWords),
                first_color:cardInfo.firstColor,
                remark_color:cardInfo.remarkColor
            },
            modelId:cardInfo.templateId,
            type:cardInfo.temTypeValue,
            open:cardInfo.temStatus
        }
        data.fieldsJson=JSON.stringify(data.fieldsJson);
        function fixedKeywordList(keywordList){
          let my_keywordList=[];
          for(let i=0;i<keywordList.length;i++){
            let objectAdapter={
                title:keywordList[i].keyNameText,
                key:keywordList[i].keyName,
                value:keywordList[i].keyValue,
              color: keywordList[i].colorValue
            }
            my_keywordList.push(objectAdapter);
          }
          return my_keywordList;
        }
        const loading=this.$loading();
        this.$axios.fetchPost(url,data).then((res)=>{
            loading.close();
            if(res.code===200){
              this.$notify({
                type: "success",
                title: '保存操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({
              //     message:'保存成功！',
              //     type:'success'
              // })
            }else{
              this.$notify({
                type: "error",
                title: '保存操作',
                message: '失败',
                showClose: false,
              });
              // this.$message.error('保存失败！'+res.errorMsg);
            }
        })
      },
      //选择的动作类型
      actionType(actionType,lifePoint=''){
        if(lifePoint){
          console.log('初始化keyValueOptions')
        }else{
            //切换选项置空当前keyWords列表。
            this.templateList[this.currentCardItemIndex].keyWords=[];
            return;
        }
        let keyWords=[];
        switch (String(actionType)) {
            case '10'://会员卡激活
                // keyValueOptions:[{label:'啊啊',value:'A01'},{label:'哈哈哈',value:'A02'}],
                console.log('第几个',this.currentCardItemIndex)
                //先赋值好可用的keyValueOptions数组。
                this.keyValueOptions=[
                   {
                      label:'会员卡号',
                      value:'card'
                   },
                   {
                      label:'会员姓名',
                      value:'name'
                   },
                   {
                      label:'会员手机',
                      value:'mobile_phone'
                   },
                   {
                      label:'当前余额',
                      value:'balance'
                   },
                   {
                      label:'会员等级',
                      value:'grade_name'
                   },
                   {
                      label:'加入时间',
                      value:'index_time'
                   }
                ]
                //更新keyValueOptions
                keyWords=this.templateList[this.currentCardItemIndex].keyWords;
                for(let i=0;i<keyWords.length;i++){
                    keyWords[i].keyValueOptions=this.keyValueOptions;
                }
                break;
            case '20'://会员卡消费
                this.keyValueOptions=[
                   {
                      label:'会员手机',
                      value:'mobile_phone'
                   },
                   {
                      label:'会员名称',
                      value:'name'
                   },
                   {
                      label:'当前余额',
                      value:'balance'
                   },
                   {
                      label:'当前积分',
                      value:'integral'
                   },
                   {
                      label:'充值金额',
                      value:'recharge_balance'
                   },
                   {
                      label:'充值状态',
                      value:'recharge_state'
                   },
                   {
                      label:'充值方式',
                      value:'pay_type'
                   },
                   {
                      label:'充值时间',
                      value:'add_time'
                   }
                ]
                //更新keyValueOptions
                keyWords=this.templateList[this.currentCardItemIndex].keyWords;
                for(let i=0;i<keyWords.length;i++){
                    keyWords[i].keyValueOptions=this.keyValueOptions;
                }
                break;
            case '30'://会员消费
                this.keyValueOptions=[
                   {
                      label:'会员卡号',
                      value:'card'
                   },
                   {
                      label:'会员手机',
                      value:'mobile_phone'
                   },
                   {
                      label:'消费金额',
                      value:'flower_balance'
                   },
                   {
                      label:'消费门店',
                      value:'store_name'
                   },
                   {
                      label:'订单编号',
                      value:'order_number'
                   },
                   {
                      label:'支付方式',
                      value:'pay_type'
                   },
                   {
                      label:'当前余额',
                      value:'balance'
                   },
                   {
                      label:'当前积分',
                      value:'integral'
                   },
                   {
                      label:'消费时间',
                      value:'add_time'
                   },
                   {
                      label:'会员名称',
                      value:'name'
                   },
                   {
                      label:'会员等级',
                      value:'grade_name'
                   },
                ]
                //更新keyValueOptions
                keyWords=this.templateList[this.currentCardItemIndex].keyWords;
                for(let i=0;i<keyWords.length;i++){
                    keyWords[i].keyValueOptions=this.keyValueOptions;
                }
                break;
            case '40'://优惠券发放
                this.keyValueOptions=[
                   {
                      label:'生效时间',
                      value:'start_time'
                   },
                   {
                      label:'到期时间',
                      value:'end_time'
                   },
                   {
                      label:'优惠券名称',
                      value:'coupon_name'
                   }
                ]
                //更新keyValueOptions
                keyWords=this.templateList[this.currentCardItemIndex].keyWords;
                for(let i=0;i<keyWords.length;i++){
                    keyWords[i].keyValueOptions=this.keyValueOptions;
                }
                break;
            case '50'://退款通知
                this.keyValueOptions=[
                   {
                      label:'会员卡号',
                      value:'card'
                   },
                   {
                      label:'会员手机',
                      value:'mobile_phone'
                   },
                   {
                      label:'退款金额',
                      value:'refund_balance'
                   },
                   {
                      label:'订单编号',
                      value:'order_number'
                   },
                   {
                      label:'退款方式',
                      value:'pay_type'
                   },
                   {
                      label:'会员名称',
                      value:'name'
                   }
                ]
                //更新keyValueOptions
                keyWords=this.templateList[this.currentCardItemIndex].keyWords;
                for(let i=0;i<keyWords.length;i++){
                    keyWords[i].keyValueOptions=this.keyValueOptions;
                }
              break;
            default:
                break;
        }
      },
      //修正keyword_list数据结构
      fixedKeyWords(keyword_list){
        let my_keyword_list=[];
        for(let i=0;i<keyword_list.length;i++){
          let objectAdapter={
            keyNameText:keyword_list[i].title,
            keyName:keyword_list[i].key,
            keyValue:keyword_list[i].value,
            keyValueOptions:[],
            colorValue:keyword_list[i].color
          }
          my_keyword_list.push(objectAdapter);
        }
        return my_keyword_list;
      },
      //删除关键词
      deleteKeyWordItem(keyWords,keyWordItemIndex){
        keyWords.splice(keyWordItemIndex,1);
      },
      //添加关键词
      addKeyWord(templateItem){
        //添加的同时判断当前动作类型对keyValueOptions重新赋值
        this.actionType(this.templateList[this.currentCardItemIndex].temTypeValue,'addKeyWord')
        templateItem.keyWords.push(
            {
                keyNameText:'',
                keyName:'',
                keyValue:'',
                keyValueOptions:this.keyValueOptions,//第一次进入该界面也更新。
                colorValue:''
            }
        )
      },
      //删除模板
      deleteTemplateItem(templateItem,templateItemIndex){
        this.$confirm('是否删除此模板？', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'info'
        }).then((res) => {
            if(res.code===200){
              this.$notify({
                type: "success",
                title: '删除操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({
              //     message:'删除成功！',
              //     type:'success'
              // })
            this.templateList.splice(templateItemIndex,1);
            }else{
              this.$notify({
                type: "error",
                title: '删除操作',
                message: '失败',
                showClose: false,
              });
              // this.$message.error('删除失败！',res.errorMsg);
            }
        }).catch(() => {
        });
      },
      //添加卡片
      addCard(){
        this.templateList.push(
            {
                title:'',
                temTypeValue:'',
                typeOptions:this.$utils.getCacheStatus('sysMerchantTemplatePush.type'),
                firstTitle:'',
                firstColor:'',
                keyWords:[
                    {
                    keyNameText:'',
                    keyName:'',
                    keyValue:'',
                    keyValueOptions:[],
                    colorValue:''
                    }
                ],
                remark:'',
                remarkColor:'',
                templateId:'',
                temStatus:false
            }
        )
      }
  }
}
</script>

<style scoped>
.lastTitle{
  height: 42px;
  padding: 0px 15px;
  border-bottom: 1px solid #f6f6f6;
  line-height: 42px;
}

.versionContent{
    margin-top:15px;
    padding:0px 15px;
    display: flex;
  flex-flow: row wrap;
}
.versionContent .oneCard{
    width: 462px;
    /* min-height: 286px; */
    border: 1px solid #ebeef5;
    padding: 0px 20px;
    box-sizing: border-box;
    margin-right:10px;
    margin-bottom: 20px;
    transition: box-shadow .5s ;
}
.versionContent .oneCard:hover{
    /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);    */
  box-shadow: 0 10px 24px 0 rgba(0, 0, 0, .1);
}

.versionContent .addCardContainer{
    margin-right:10px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.versionContent .addCardContainer .addCard{
    width: 102px;
    height: 102px;
    border: 1px solid #dcdfe6;

    font-size: 60px;
    text-align: center;
    line-height: 102px;
  color: #C0C4CC;
}
.versionContent .oneCard .settingItem{
    height: 48px;
    padding: 10px 0px;
    display: flex;
}
.versionContent .oneCard .itemRightWidth{
    width:50px;
    margin-left: 16px;

    font-size: 18px;
    text-align: right;
    color: #c0c4cc;
    line-height: 28px;
    cursor: pointer;
}
.versionContent .oneCard .itemLeftWidth{
    width:86px;

    text-align: left;
    line-height: 28px;
    font-size: 14px;
    color: #333333;
}
.versionContent .oneCard .specialItemRightWidth{
    display: flex;
    align-items: center;
    margin-left:5px;

    font-size:18px;
}
.versionContent .oneCard .specialItemRightWidth i{
    margin-left: 5px;
}
.versionContent .oneCard .settingItem .itemDelete{
    color: #409EFF;
    cursor: pointer;
}

.el-select, .el-input, .el-input-number{
    width: 100%;
}
.versionLast>>>.el-select .el-input{
    width: 100%;
}
.versionLast>>>.el-color-picker__trigger{
    width: 32px;
    height: 32px;
}
.versionLast>>>.el-color-picker{
    height: 30px;
}
.specialInput>>>.el-input__inner{
    border-left-color: #ffffff;
    border-right-color: #ffffff;
    border-top-color: #ffffff;
}
.versionLast>>>.el-switch{
    line-height: 26px;
    height: 28px;
}

</style>



// WEBPACK FOOTER //
// src/page/system/wechat/VersionLast.vue